<template>
  <div :class="classObj" class="app-wrapper">
    <topbar v-if="!setloading"/>
    <sidebar class="sidebar-container" v-if="!loading"/>
    <div class="main-container" v-if="!loading">
      <app-main/>
    </div>
    <div v-loading.fullscreen.lock="loading" v-else></div>
  </div>
</template>

<script>
import { Sidebar, AppMain, Topbar } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',
  components: {
    Sidebar,
    AppMain,
    Topbar
  },
  mixins: [ResizeMixin],
  computed: {
    setloading(){
      return this.$store.state.user.setloading
    },
    loading() {
      return this.$store.state.user.loading
    },
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
</style>
